module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messagepage"
  }, [_c('div', {
    staticClass: "right_col",
    attrs: {
      "role": "main"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "x_panel"
  }, [_c('div', {
    staticClass: "x_content"
  }, [_c('table', {
    staticClass: "table table-bordered datatable"
  }, [_c('tbody', [_vm._m(1), _vm._l((_vm.forms), function(form, index) {
    return _c('tr', [_c('td', {
      staticClass: "tdcentersmall"
    }, [(form.is_valid == 1) ? _c('p', {
      staticClass: "enable"
    }, [_vm._v("有効")]) : _c('p', {
      staticClass: "disabled"
    }, [_vm._v("無効")])]), _c('td', {
      staticClass: "updowncenter"
    }, [_c('p', [_vm._v(_vm._s(form.name))])]), _c('td', {
      staticClass: "tdcenter"
    }, [_c('router-link', {
      staticClass: "btn btn-success",
      attrs: {
        "to": {
          name: 'messages',
          params: {
            id: form.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-envelope",
      attrs: {
        "id": "readingmessage",
        "aria-hidden": "true"
      }
    }, [_vm._v(" メッセージを見る")])])], 1), _c('td', {
      staticClass: "tdcenter"
    }, [_c('p', [_vm._v(_vm._s(form.not_correspondence))])]), _c('td', {
      staticClass: "tdcenter"
    }, [_c('p', [_vm._v(_vm._s(form.during_correspondence))])])])
  })], 2)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('div', {
    staticClass: "title_left"
  }, [_c('h2', [_vm._v("メッセージ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "active"
  }, [_c('th', {
    staticClass: "isvalid"
  }, [_vm._v("有効・無効")]), _c('th', {
    staticClass: "formname"
  }, [_vm._v("フォーム名")]), _c('th', {
    staticClass: "readingmessagebutton"
  }, [_vm._v("メッセージ")]), _c('th', {
    staticClass: "notcompatible"
  }, [_vm._v("未対応")]), _c('th', {
    staticClass: "nowcorrespondence"
  }, [_vm._v("対応中")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a6cea57","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Information.vue
// module id = 590
// module chunks = 1